import React, { Component } from 'react'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'

class Refinement extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      items,
      refine,
      dropdown,
      label,
      isFromSearch,
      createURL,
      showMore,
    } = this.props
    return (
      <React.Fragment>
        {items.map(item => (
          <li className="article-tab" key={item.label}>
            <a
              className={`${item.isRefined ? `active` : ``}`}
              href={createURL(item.value)}
              onClick={event => {
                event.preventDefault()
                refine(item.value)
              }}
            >
              {isFromSearch ? (
                <Highlight attribute="label" hit={item} />
              ) : (
                item.label
              )}{` `}
            </a>
          </li>
        ))}
      </React.Fragment>
    )
  }
}

const ArticleRefinement = connectRefinementList(Refinement)

export default ArticleRefinement
